import { SEVERITY_PALETTE, type SeverityKey } from "@safers/ui/styles/severity";

export const SEVERITY_LABELS: Record<SeverityKey, string> = {
  NORMAL: "정상",
  ATTENTION: "관심",
  CAUTION: "주의",
  WARNING: "경고",
  CRITICAL: "위험",
  UNCERTAIN: "불확실",
};

export const severityColor = (severity: SeverityKey) => SEVERITY_PALETTE[severity].fill;
export const severityTextColor = (severity: SeverityKey) => SEVERITY_PALETTE[severity].panelFg;
